import React from 'react'
import { Redirect } from 'react-router-dom'

import {get} from './../../utils/Storage';

import {
    Route,
  } from "react-router-dom";
  

export default function ProtectedRoute({exact, path, component}){
    let token = get('token');

    const isAuthenticated = token ? true : false;

    return isAuthenticated ? (
        <Route exact={exact} path={path}   component={component}/>
    ) : (
        <Redirect to={{ pathname: '/login' }} />
    );
}